export default __webpack_public_path__ + "static/TOY7296 LGP Logo Header Image-ccf51dd668b54a6d3fc9393af4595083.png";